"use client";

import { motion } from "framer-motion";
import Image from "next/image";

export default function HeroSection() {
    return (
        <section className="relative min-h-screen lg:h-screen bg-white text-black overflow-hidden" data-header-theme="dark">
            {/* Top Navigation Bar - Absolute to span across */}


            <div className="grid grid-cols-1 lg:grid-cols-[28%_44%_28%] min-h-screen lg:h-screen pt-24 lg:pt-[5rem] xl:pt-28">

                {/* COLUMN 1: Branding & Info */}
                <div className="flex flex-col justify-between p-6 lg:px-8 lg:py-8 lg:pb-10 xl:p-12 xl:pb-16 lg:border-r border-black/10 relative order-2 lg:order-1">
                    <div className="mt-8 lg:mt-2 xl:mt-10">
                        {/* Main Title */}
                        <motion.h1
                            initial={{ opacity: 0, y: 20 }}
                            animate={{ opacity: 1, y: 0 }}
                            className="text-4xl md:text-5xl lg:text-[2.2vw] font-bold tracking-tighter mb-8 lg:mb-4 xl:mb-12 leading-[1.1]"
                        >
                            <span className="block whitespace-nowrap">AUGMENTED REALITY</span>
                            <span className="block whitespace-nowrap">VIRTUAL REALITY</span>
                            <span className="block whitespace-nowrap">EXTENDED REALITY</span>
                        </motion.h1>
                    </div>

                    {/* Subheading */}
                    <motion.div
                        initial={{ opacity: 0 }}
                        animate={{ opacity: 1 }}
                        transition={{ delay: 0.2 }}
                        className="space-y-4 xl:space-y-6 mt-12 lg:mt-0"
                    >
                        <div className="space-y-4 max-w-xs text-sm text-gray-600 leading-relaxed">
                            <p>Future of Interaction</p>
                            <p className="text-[1.125rem]">
                                Create a immersive experiences that blur the line between the physical and digital worlds for varied industries.
                            </p>
                        </div>
                    </motion.div>
                </div>

                {/* COLUMN 2: Main Hero Image */}
                <div className="relative lg:border-r border-black/10 overflow-hidden bg-white min-h-[50vh] lg:min-h-0 order-1 lg:order-2">
                    <motion.div
                        initial={{ opacity: 0, scale: 1.1 }}
                        animate={{ opacity: 1, scale: 1 }}
                        transition={{ duration: 1.2 }}
                        className="w-full h-full relative"
                    >
                        {/* Background glow effect behind the head */}
                        <div className="absolute top-1/4 left-1/2 -translate-x-1/2 w-[500px] h-[500px] bg-blue-500/20 rounded-full blur-[100px] pointer-events-none"></div>

                        <img
                            src="/images/ar-vr/hero-ar-industrial-hololens.png"
                            alt="Industrial AR Visualization"
                            className="w-full h-full object-cover object-top"
                        />

                        {/* Gradient overlay at bottom to blend if needed */}
                        <div className="absolute bottom-0 w-full h-32 bg-gradient-to-t from-white to-transparent"></div>
                    </motion.div>
                </div>

                {/* COLUMN 3: Secondary Feature & Navigation */}
                <div className="flex flex-col justify-between p-6 lg:px-8 lg:py-8 lg:pb-10 xl:p-12 xl:pb-16 relative bg-white order-3">

                    {/* Secondary Image Carousel */}
                    <div className="w-[85%] lg:w-[60%] xl:w-[75%] max-w-[320px] mx-auto xl:max-w-none aspect-[4/5] relative mb-8 lg:mb-4 xl:mb-8 mt-8 lg:mt-0 group">
                        <div className="w-full h-full rounded-full lg:rounded-none lg:rounded-t-full overflow-hidden border border-black/5 relative">
                            <img
                                src="/images/ar-vr/hero-ar-furniture-app-v2.png"
                                alt="AR Furniture App Demo"
                                className="w-full h-full object-cover"
                            />
                        </div>
                    </div>

                    {/* Text Content */}
                    <div className="mt-auto space-y-4 xl:space-y-6">
                        <motion.h3
                            initial={{ opacity: 0, x: 20 }}
                            animate={{ opacity: 1, x: 0 }}
                            transition={{ delay: 0.3 }}
                        >
                            Spatial
                            Computing
                        </motion.h3>

                        <p className="text-[1.125rem] text-gray-600 leading-relaxed">
                            We build robust platforms that redefine how users interact and experience with digital content.
                        </p>

                    </div>
                </div>

            </div>
        </section>
    );
}
